<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">

                                    پاسخ های کاربران

                                </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                               
                            </a-col>
                        </a-row>
                    </template>


                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                         <div class="table-responsive">

                             <table class="table ">
                    <thead>
                        <tr>
                       
                            <th scope="col">شناسه</th>
                            <th scope="col"> نام کاربر</th>
                            <th scope="col">عملیات </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in data">
                            
                          
                            <th scope="row">#{{ row . id }}</th>
                            <td>
                            
                                <b-badge variant="light" class="text-dark"> {{row[0].user ?  $root.full_name(row[0] . user . firstname , row[0] . user . lastname) : '' }}</b-badge>
                            </td>

                            <td>
                              

<AnswersModal :answers="row" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                            </div>
                        </section>
                        
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>

    import AnswersModal from '../../components/Seminars/ModalAnswers.vue';

    export default {
        components:{
AnswersModal,
        },
       data() {
            return {
                loading: false,
                visible: false,
                isHidden: false,
                currentPage: 1,
                total: 0,
                info:{},
                data:[]
               
            };
        },
       
        methods: {
            async getData() {
            let _this = this;
            axios
                .get("/questions/answers/" + this.$route.params.id)
                .then(function(response) {
                    _this.$store.state.loading = false;
                    _this.data = response.data;
                    // _this.total = response.data.total;
                    // _this.current_page = response.data.current_page;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
            },
           
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
